import { Box } from "@mui/material";
import { FONT, TEXT_DARK, TEXT_SECONDARY } from "./bentoTokens";

// Outer page wrapper matching scenes/financial's layout: capped width, responsive padding,
// bento heading style, and an optional right-aligned slot for tabs/buttons.
const PageShell = ({ title, subtitle, actions, children, sx }) => {
  const hasHeader = Boolean(title || subtitle || actions);
  return (
    <Box sx={{ maxWidth: 1280, mr: "auto", p: { xs: "20px", md: "30px 40px 48px" }, fontFamily: FONT, ...sx }}>
      {hasHeader && (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
          <Box>
            {title && (
              <Box component="h1" sx={{ m: 0, fontSize: 26, fontWeight: 800, color: TEXT_DARK, letterSpacing: "-.01em" }}>
                {title}
              </Box>
            )}
            {subtitle && (
              <Box sx={{ mt: "4px", fontSize: 14, color: TEXT_SECONDARY }}>{subtitle}</Box>
            )}
          </Box>
          {actions}
        </Box>
      )}
      <Box sx={{ mt: hasHeader ? "26px" : 0 }}>{children}</Box>
    </Box>
  );
};

export default PageShell;
